import React from "react";
import MachinesBaseEditor from "./MachinesBaseEditor";
import TeamsBaseEditor from "./TeamsBaseEditor";
import MaintenanceScheduleEditor from "./MaintenanceScheduleEditor";
import ContractHoursCalendarEditor from "./ContractHoursCalendarEditor";
import MonthlyMachineCapacityPanel from "./MonthlyMachineCapacityPanel";

export default function SimulationBasesPanel({ bases, periods }) {
  if (!bases) return null;

  const { machines, maintenanceSchedule, operatorsSummary, actions, calendarMaps } = bases;
  const maintenanceEntries = bases.maintenanceWindows || maintenanceSchedule || [];
  const contractHoursCalendar = bases.contractHoursCalendar || [];
  const teamAbsences = bases.teamAbsences || [];
  const teamBoosts = bases.teamBoosts || [];
  const monthlyMachineCapacity = bases.monthlyMachineCapacity || null;

  return (
    <div className="swb-base-stack">
      <section className="swb-panel swb-panel--accent">
        <div className="swb-panel__head">
          <h3>Bases da simulacao (mock local)</h3>
          <span className="swb-subtle">
            Editar aqui altera o calculo do workbench. Periodos ativos: {(periods || []).join(", ")}
          </span>
        </div>
        <p className="swb-subtle">
          Estas bases estao persistidas em localStorage apenas para validacao de UX/arquitetura.
        </p>
      </section>

      <MonthlyMachineCapacityPanel monthlyMachineCapacity={monthlyMachineCapacity} />

      <MachinesBaseEditor
        machines={machines}
        onAdd={actions.addMachine}
        onUpdate={actions.updateMachine}
        onRemove={actions.removeMachine}
      />

      <TeamsBaseEditor
        machines={machines}
        operatorsSummary={operatorsSummary}
        noWorkEntries={teamAbsences}
        boostEntries={teamBoosts}
        onAddNoWork={actions.addTeamAbsence}
        onRemoveNoWork={actions.removeTeamAbsence}
        onToggleNoWorkDate={actions.toggleMachineNoWorkDate}
        onAddBoost={actions.addTeamBoost}
        onRemoveBoost={actions.removeTeamBoost}
        onToggleDoubleDate={actions.toggleMachineDoubleSlotDate}
      />

      <MaintenanceScheduleEditor
        entries={maintenanceEntries}
        machines={machines}
        calendarMaps={calendarMaps}
        onAdd={actions.addMaintenanceWindow}
        onToggleDate={actions.toggleMaintenanceDate}
        onRemove={actions.removeMaintenanceWindow}
      />

      <ContractHoursCalendarEditor
        entries={contractHoursCalendar}
        machines={machines}
        calendarMaps={calendarMaps}
        onAdd={actions.addContractHourDay}
        onUpdate={actions.updateContractHourDay}
        onRemove={actions.removeContractHourDay}
        onSetDayHours={actions.setContractHoursForDate}
        onFillYear={actions.fillContractHoursYear}
      />
    </div>
  );
}
